import { formatCurrencyNoDecimals } from "../../../utils";

const TOOLTIP_STYLE = {
  borderRadius: "12px",
  border: "1px solid var(--chart-tooltip-border)",
  boxShadow: "0 4px 12px var(--chart-tooltip-shadow)",
  fontSize: "12px",
  padding: "12px 16px",
  backgroundColor: "var(--chart-tooltip-bg)",
} as const;

type Payload = { name?: string; value?: number; color?: string };

interface Props {
  active?: boolean;
  payload?: Payload[];
  label?: string;
  formatValue?: (value: number) => string;
}

export default function ChartTooltip({ active, payload, label, formatValue }: Props) {
  if (!active || !payload?.length) return null;

  const format = formatValue ?? function defaultFormat(v: number) {
    return formatCurrencyNoDecimals(v);
  };

  return (
    <div style={TOOLTIP_STYLE}>
      <p className="text-body-bold-xs content-base-primary mb-1">{label}</p>
      {payload.map(function renderEntry(entry, idx) {
        return (
          <div key={idx} className="flex items-center gap-2 py-0.5">
            <div className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: entry.color }} />
            <span className="text-body-regular-xs content-base-secondary">{entry.name}</span>
            <span className="text-body-bold-xs content-base-primary ml-auto">{format(entry.value ?? 0)}</span>
          </div>
        );
      })}
    </div>
  );
}
